import React from "react";
import { Colors } from "../../common/Const";

function TextBox({
  suffix = 1,
  place,
  type,
  change,
  input_value,
  name,
  prefix,
  bg_color
}) {
  return (
    <div className="d-flex m-2 p-2 align-items-center" style={{borderBottom: `2px solid #126a38`}}>
      {prefix}
      <input
        autoComplete="off"
        className="Text_box w-100 px-3"
        type={type}
        placeholder={place}
        name={name}
        value={input_value}
        onChange={(e) => change(e.target.value)}
        style={{color: Colors.Base_color, fontSize:'18px', backgroundColor: bg_color ? bg_color : "#fff"}}
      />
      {suffix !== 1 ? suffix : null}
    </div>
  );
}

export default TextBox;
